import { IDraftFrame, IDraftLinkedAsset } from 'types/detailsEntityType';

import { DraftStatus } from '../../../utils/statuses';

export const generateDraftEntityFilters = (
  frames: IDraftFrame[],
  linkedAssets: IDraftLinkedAsset[]
) => {
  const filterSets = {
    spaceIds: new Set<string>(),
    mediaOwnerNames: new Set<string>(),
    environments: new Set<string>(),
    formatSizeNames: new Set<string>(),
    statuses: new Set<DraftStatus>(),
  };

  const addToFilters = (item: IDraftFrame | IDraftLinkedAsset) => {
    filterSets.statuses.add(item.status);
    if (item.mediaOwnerName) filterSets.mediaOwnerNames.add(item.mediaOwnerName);
    if (item.environment) filterSets.environments.add(item.environment);
    if (item.formatSize && item.formatSize.name)
      filterSets.formatSizeNames.add(item.formatSize.name);
    filterSets.spaceIds.add(item.spaceId);
  };

  [...frames, ...linkedAssets].forEach(addToFilters);

  return Object.fromEntries(
    Object.entries(filterSets).map(([key, value]) => [key, Array.from(value)])
  );
};
